
import "./manageusers.css";
import DataTable from 'react-data-table-component';
import { Dropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import HttpClient from '../utils/HttpClient';
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import withReactContent from 'sweetalert2-react-content';
import toast from "react-hot-toast";
import Select from 'react-select';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const MySwal = withReactContent(Swal);

const ManageProject = () => {
  const [tableData, setTableData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [projectId, setProjectId] = useState("")
  const [isModal, setIsModal] = useState(false);
  const [assignedUserData, setAssignedUserData] = useState([])
  const navigate = useNavigate();
  console.log("assignedUserDatasfgd", assignedUserData)
  useEffect(() => {
    const toastMessage = sessionStorage.getItem('toastMessage');
    if (toastMessage) {
      toast.success(toastMessage);
      sessionStorage.removeItem('toastMessage');
    }
  }, []);

  // >>>>Formating the option<<<<
  const formatOptions = (data) => {
    return data?.map(user => ({
      value: user._id,
      label: `${user.firstName} ${user.lastName} (${user?.emailID})`
    }));
  };

  // >>>>Fetch User Data<<<<
  const fetchAllUsers = async () => {
    try {
      const res = await HttpClient.requestData("user-list", "GET");
      if (res && res?.status) {
        // setAllUsersList(res?.data);
        setOptions(formatOptions(res?.data)); 
      } else {
        toast.error("Failed to fetch user data.");
      }
    } catch (error) {
      toast.error("An error occurred while fetching user data.");
    }
  };

  // >>>>Navigate to Add Project Page<<<<
  const goToAddProject = () => {
    navigate("/manageprojectform");
  };

  // >>>>Fetch All Project<<<<
  const getProject = async () => {
    try {
      const res = await HttpClient.requestData("project", "GET");
      if (res && res.status) {
        const newArr = res.data.map((item, i) => {
          const fullItemNames = item?.itemData?.map(ele => ele?.itemName).join(', ');
          const fullAssignedUser = item?.assignData?.map(ele => `${ele?.userData?.firstName} ${ele?.userData?.lastName}`)?.join(', ')
          return {
            sln: i + 1,
            projectName: item?.projectName,
            itemName: `${fullItemNames?.slice(0, 30)}...`, 
            fullItemNames: fullItemNames,
            // itemName: `${item?.itemData?.map(ele => ele?.itemName)?.join(', ')?.slice(0, 30)}...`,
            status: item?.status,
            assignedUser: `${fullAssignedUser?.slice(0, 30)}...`,
            fullAssignedUser: fullAssignedUser,
            // assignedUser: item?.assignData?.map(ele => `${ele?.userData?.firstName} ${ele?.userData?.lastName}`)?.join(', '), 
            id: item?._id,
            viewAssignedUser: (
              <span onClick={() => handleAssignedUserProject(item?._id)} style={{ cursor: "pointer" }}>
                <i class="fa-solid fa-eye"></i>
              </span>
            )
          };
        });
        setTableData(newArr);
      } else {
        toast.error('Failed to fetch project data.');
      }
    } catch (error) {
      console.error('Error fetching project data:', error);
      toast.error('An error occurred while fetching project data.');
    }
  };

  // >>>>Coloum Declaration<<<<
  const columns = [
    {
      name: 'SL',
      selector: row => row.sln,
      sortable: true,
      wrap: true
    },
    {
      name: 'Project Name',
      selector: row => row.projectName,
      sortable: true,
      wrap: true
    },
    {
      name: 'Items-Name',
      cell: row => (
        <div className="tooltipItem">
          {row.itemName}
          <span className="tooltipItemName">
            <ol>
              {row.fullItemNames.split(', ').map((item, index) => (
                <li key={index} style={{textAlign:"justify", borderBottom:"1px solid #ccc", padding:"5px 0"}}>{item}</li> // Create a list item for each full item name
              ))}
            </ol>
          </span>
        </div>
      ),
      sortable: true,
      wrap: true
    },
    {
      name: 'Status',
      selector: row => row.status,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Assigned-User',
      cell: row => (
        <div className="tooltipItem">
          {row.assignedUser}
          <span className="tooltipItemName">
            <ol>
              {row.assignedUser.split(', ').map((item, index) => (
                <li key={index} style={{textAlign:"justify", borderBottom:"1px solid #ccc", padding:"5px 0"}}>{item}</li> // Create a list item for each full item name
              ))}
            </ol>
          </span>
        </div>
      ),
      sortable: true,
      wrap: true
    },
    {
      name: 'Action',
      cell: row => (
        <Dropdown>
          <Dropdown.Toggle variant="link" id="dropdown-basic" style={{ border: 'none', boxShadow: 'none', textDecoration: "none", color: "rgb(208, 38, 38)" }}>
            <span className="ellipsis">•••</span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => handleStatus(row, row?.status === "Active" ? "Inactive" : "Active")}>{row?.status === "Active" ? "Inactive" : "Active"}</Dropdown.Item>
            <Dropdown.Item onClick={() => handleEdit(row)}>Edit</Dropdown.Item>
            <Dropdown.Item onClick={() => handleAddProject(row)}>Add User</Dropdown.Item>
            <Dropdown.Item onClick={() => handleDelete(row)}>Delete</Dropdown.Item>
            <Dropdown.Item onClick={() => navigate('/data-upload', { state: row?.id })}>Data Upload</Dropdown.Item>

          </Dropdown.Menu>
        </Dropdown>
      ),
      sortable: false,
      wrap: true,
    },
    {
      name: 'View-Assigned-User',
      selector: row => row.viewAssignedUser,
      sortable: true,
      wrap: true,
    },
  ];

  // >>>>handleAssignedUserProject<<<<
  const handleAssignedUserProject = async (id) => {
    setIsModal(!isModal)
    if (id) {
      const res = await HttpClient.requestData(`project-assigned-users/${id}`, "GET");
      if (res && res?.status) {
        setAssignedUserData(res?.data)
      } else {
        setAssignedUserData([])
      }
    }
  }

  // >>>>Handle Edit<<<<
  const handleEdit = (item) => {
    console.log("sdf445d", item, item?.id);
    const { projectName, itemName, id } = item;
    // Only pass serializable data
    navigate("/manageprojectform", { state: { projectName, itemName, id } });
  };


  const handleDelete = async (item) => {
    const result = await MySwal.fire({
      title: 'Are you sure?',
      text: 'You are about to delete this project!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      confirmButtonColor: '#d33',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    });

    if (result.isConfirmed) {
      try {
        const response = await HttpClient.requestData(`project/${item.id}`, "DELETE");

        if (response && response.status) {
          MySwal.fire('Deleted!', 'Project has been deleted.', 'success');
          getProject();
        } else {
          MySwal.fire('Error!', 'Failed to delete project.', 'error');
        }
      } catch (error) {
        console.error('Error deleting project:', error);
        MySwal.fire('Error!', 'Failed to delete project.', 'error');
      }
    }
  };

  const handleStatus = async (item, status) => {
    console.log("sd5f3s1", item, status)
    // return
    console.log("problem", item)
    try {
      const res = await HttpClient.requestData(`project-status/${item.id}`, "PUT", { status: status });
      if (res && res.status) {
        toast.success(`Project status changed to ${status}.`);
        getProject();
      } else {
        toast.error('Failed to update project status.');
      }
    } catch (error) {
      console.error('Error updating status:', error);
      toast.error('An error occurred while updating the status.');
    }
  };

  const handleAddProject = (row) => {
    // console.log("4sfg651", row)
    // return
    if (row) {
      setModalOpen(true)
      setProjectId(row?.id)
    } else {
      setModalOpen(false)
      setProjectId("")
      setSelectedUser(null)
    }
    // navigate("/assign-to-user", { state: row });
  };

  // >>>>Handle Select change<<<<
  const handleSelectChange = (selectedOption) => {
    setSelectedUser(selectedOption);
  };

  useEffect(() => {
    getProject();
    fetchAllUsers();
  }, []);

  const filteredData = tableData.filter(item =>
    item.projectName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // >>>>Handle Add User<<<<
  const handleAddUserClick = async () => {
    const userIds = selectedUser.map(user => user.value);

    if (!selectedUser || selectedUser.length === 0) {
      return toast.error("Please select at least one user!");
    }

    const data = {
      projectID: projectId,
      userID: userIds
    };

    try {
      if (data) {
        const res = await HttpClient.requestData("project-assign", "POST", data)
        if (res && res?.status) {
          toast.success(res?.message || "Project assigned successfully!");
          setSelectedUser(null);
          setModalOpen(false);
          getProject();
          fetchAllUsers();
        } else {
          toast.error(res?.message || "Something went wrong!");
        }
      }
    } catch (error) {
      toast.error("Error assigning project:", error.message);
    }
  };


  return (
    <div className='manageUsers'>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h3 style={{ fontSize: "20px" }}>Manage Project</h3>
        <h3 style={{ fontSize: "15px", color: "rgb(208, 38, 38)", cursor: "pointer" }} onClick={goToAddProject}>+Add Project</h3>
      </div>

      <div className='userSearc'></div>

      <div className="userSelector" style={{ marginTop: "20px" }}>
        <div className="mb-3" style={{ display: "flex", justifyContent: "space-between" }}>

          {/* Search Input */}
          <div className="header-container Search_box d-flex justify-content-start p-2">
            <form className="form-inline" style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.5)" }} onSubmit={(e) => e.preventDefault()}>
              <input
                className="form-control"
                type="search"
                placeholder="Search by project name..."
                aria-label="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button className="Search_icon" type="submit">
                <i className="fa-solid fa-magnifying-glass"></i>
              </button>
            </form>
          </div>

        </div>
      </div>

      <DataTable
        className="dataTableContainer"
        columns={columns}
        data={filteredData}
        pagination
        highlightOnHover
        striped
        noHeader={true}
        customStyles={{
          table: {
            style: {
              minHeight: '350px',
              maxHeight: '500px',
            },
          },
          headCells: {
            style: {
              whiteSpace: 'normal',
            },
          },
        }}
      />

      <footer style={{ position: "fixed", bottom: "0", width: "100%", padding: "10px 0", zIndex: "1", backgroundColor: "#fff" }}>
        <p style={{ fontSize: "12px", color: "#666" }}>Copyright © 2024 Psedge. All rights reserved.</p>
      </footer>

      {/* Assign to User Modal */}
      <Modal isOpen={modalOpen} toggle={() => { setModalOpen(false); setSelectedUser(null) }}>
        <ModalHeader toggle={() => { setModalOpen(false); setSelectedUser(null) }}>Manage Project Users</ModalHeader>
        <ModalBody>
          {/* Select User */}
          <div className="mt-2">
            <label>Select User</label>
            <Select
              isMulti
              className='w-100'
              value={selectedUser}
              onChange={handleSelectChange}
              options={options}
              placeholder="Select User"
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <div className='d-flex justify-content-center gap-2 w-100'>
            <button className="btn btn-outline-success w-50" onClick={handleAddUserClick}>Submit</button>
            <button className="btn btn-outline-secondary w-50" onClick={() => { setModalOpen(false); setSelectedUser(null) }}>Cancel</button>
          </div>
        </ModalFooter>
      </Modal>

      {/*View Assign User Modal */}
      <Modal isOpen={isModal} toggle={() => setIsModal(false)} size="xl">
        <ModalHeader toggle={() => setIsModal(false)}>View Assigned Users</ModalHeader>
        <ModalBody>
          <table className="table">
            <thead>
              <tr>
                <th>Sl</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email ID</th>
                <th>Organization</th>
                <th>Address</th>
                <th>Image</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {assignedUserData && assignedUserData.length === 0 ? (
                <tr>
                  <td colSpan="8" style={{ textAlign: 'center', color: "#ccc", fontWeight: "bold", fontSize: "35px" }}>No Data Found</td>
                </tr>
              ) : (
                assignedUserData.map((item, ind) =>
                  item.userData.map((user) => (
                    <tr key={user._id}>
                      <td>{ind + 1}</td>
                      <td>{user.firstName}</td>
                      <td>{user.lastName}</td>
                      <td>{user.emailID}</td>
                      <td>{user.organizationName}</td>
                      <td>{user.address}</td>
                      <td>
                        <img src={user.image} alt="user" style={{ width: '50px', height: '50px' }} />
                      </td>
                      <td>{user.status}</td>
                    </tr>
                  ))
                ))
              }
            </tbody>

          </table>
        </ModalBody>
        <ModalFooter>
          <div className='d-flex justify-content-center gap-2 w-100'>
            <button className="btn btn-outline-secondary w-50" onClick={() => setIsModal(false)}>Close</button>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ManageProject;